// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2zOsA","colMaxWidth":"Table_colMaxWidth__3M17E"};